angular.module('paymentmethods')
    .directive('paymentMethodPicker', function ($filter, $timeout, PaymentMethod) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: true,
            scope: {
                modelType: "=?",
            },
            template: `
                <div>
                    <select class="form-control input-sm" ng-model="selected" ng-change="onChange(selected)" title="{{ 'invoice.payment.method' | translate}}" required="required"
                            ng-options="u as u.name for u in methods "></select>
                </div>
            `,
            link: function (scope, $element, $attrs, ngModelCtrl) {
                scope.modelType = scope.modelType || "object"

                PaymentMethod.query().$promise.then(items => {
                    scope.methods = items.map(it => ({
                        id: it.id,
                        name: $filter('localized')(it.name)
                    }));
                    ngModelCtrl.$render();
                });

                ngModelCtrl.$render = () => {
                    scope.selected = ngModelCtrl.$viewValue;
                    if (ngModelCtrl.$viewValue && scope.methods) {
                        let elemExists = null
                        if(typeof scope.selected === 'string'){
                            elemExists = scope.methods.find(it => {
                                const firstChar = scope.selected?.charAt(0).toUpperCase();
                                const remainingChars = scope.selected?.slice(1);
                                return it.name === `${firstChar}${remainingChars}`
                            });
                            scope.selected = elemExists;
                            ngModelCtrl.$viewValue = elemExists;
                        }
                        else {
                            elemExists = scope.methods.find(it => it.id === scope.selected.id && it.name === scope.selected.name);
                            if(elemExists != null){
                                scope.selected = elemExists;
                                ngModelCtrl.$viewValue = elemExists;
                            }
                            else {
                                let custom = {id: scope.selected.id, name: scope.selected.name};
                                scope.methods.push(custom);
                                scope.selected = custom;
                                ngModelCtrl.$viewValue = custom;
                            }
                        }
                    }
                };
                ngModelCtrl.$formatters.push(modelValue => modelValue);
                ngModelCtrl.$parsers.push(viewValue => viewValue);

                scope.$watch('selected', () => {
                    ngModelCtrl.$setViewValue(scope.selected);
                    ngModelCtrl.$validate();
                    ngModelCtrl.$render();
                });
            }
        };
    });
